import { useState } from "react";

import { inject, observer } from "mobx-react";
import { computed } from "mobx";

import InputUI from "@UI/InputUI";
import { translit } from "@utils";

import "./style.scss";
import ButtonUI from "@UI/ButtonUI";

const CloneCompany = inject("mainStore")(
    observer(({ mainStore, refClose }) => {
        const modal = computed(() => mainStore.getMainStore("modal")).get();
        const offer = modal && modal.offer ? modal.offer : false;
        const [state, setState] = useState({ title: "", code: "" });
        const [newId, setNewId] = useState(false);

        const handleChange = (e) => {
            setState({ title: e.target.value, code: translit(e.target.value) });
        };

        const saveHandler = async () => {
            const resp = await mainStore.postByUrl(
                "/promo/clone_offer",
                {
                    offerId: offer._id, //на какой сайт
                    title: state.title, //какие офферы
                    code: state.code,
                    technicalName: `${offer.technicalName}-[копия]`,
                },
                false,
            );

            if (resp && resp.success && resp.data) {
                mainStore.setMainStore("toast", { severity: "success", summary: "Оффер успешно клонирована" });
                setNewId(resp.data._id);
            }
        };

        const handleOpen = () => {
            mainStore.setMainStore("modal", false);
            window.open(`/companies/${newId}`);
        };

        return (
            offer && (
                <div className="cloneItem" ref={refClose}>
                    <div className="copyItems__text">
                        Вы выбрали оффер
                        <ul>
                            <li dangerouslySetInnerHTML={{ __html: offer.title }}></li>
                        </ul>
                    </div>
                    <div className="cloneItem__inputs">
                        <InputUI value={state?.title} label="Изменить название" placeholder="Укажите изменения" addClass="full" onChange={handleChange} disabled={!!newId} />
                        <InputUI value={state?.code} label="Изменить код" placeholder="Укажите изменения" addClass="full" disabled={!!newId} />
                    </div>
                    <div className="cloneItem__buttons">
                        {newId ? (
                            <ButtonUI label={`Открыть новый оффер`} severity="info" outlined raised onClick={handleOpen} />
                        ) : (
                            <ButtonUI label={`Клонировать оффер`} severity="info" raised onClick={saveHandler} disabled={!(state?.title && state?.code)} />
                        )}
                    </div>
                </div>
            )
        );
    }),
);

export default CloneCompany;
